import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Per-location "Send emails to customers" switch (OFF by default) + daily limit.
export const SendSwitch = ({ c, canManage, onChange }) => {
  const [limit, setLimit] = useState(c.daily_limit || 40);
  const save = async (on, lim = limit) => {
    try {
      await axios.put(`${API}/outlook/send-settings`, { send_enabled: on, daily_limit: Number(lim) || 40 });
      toast.success(on ? "Customer emails turned ON for this location" : "Customer emails turned OFF");
      onChange();
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save"); }
  };
  return (
    <div className="rounded-lg border p-3 flex flex-wrap items-center gap-3" data-testid="outlook-send-settings">
      <Switch checked={!!c.send_enabled} disabled={!canManage} onCheckedChange={(v) => save(v)} data-testid="outlook-send-switch" />
      <div className="flex-1 min-w-[200px] text-sm">
        <b>Send emails to customers</b> <span className={c.send_enabled ? "text-emerald-700 font-bold" : "text-gray-500"}>{c.send_enabled ? "ON" : "OFF"}</span>
        <div className="text-xs text-gray-500">Lets staff send approved follow-up emails from {c.email}. Skips Gingr email opt-outs, booked leads and upcoming tours; max 1 per lead per 48h.</div>
      </div>
      <label className="text-xs text-gray-600 flex items-center gap-1.5">Daily limit
        <Input type="number" min={1} max={500} value={limit} disabled={!canManage} onChange={(e) => setLimit(e.target.value)}
          onBlur={() => Number(limit) !== c.daily_limit && save(!!c.send_enabled)} className="w-20 h-8" data-testid="outlook-send-limit" />
      </label>
    </div>
  );
};
